/**
 * StatsSection — horizontal bar with four animated counters
 * (writers, journals, subscriptions, paid out).
 */

import { useTranslation } from 'react-i18next';

import {
  StatsBar,
  StatsInner,
  StatItem,
  StatValue,
  StatPrefix,
  StatLabel,
} from '../../common/LandingPage.styled';
import { Counter } from '../../common/Counter';
import type { RoundedStat } from '../../common/stats';

export interface StatsSectionProps {
  writers: RoundedStat;
  journals: RoundedStat;
  subscriptions: RoundedStat;
  paidOut: RoundedStat;
}

export function StatsSection({ writers, journals, subscriptions, paidOut }: StatsSectionProps) {
  const { t } = useTranslation();

  const items = [
    { label: t('landing.stats.writers'), stat: writers },
    { label: t('landing.stats.journals'), stat: journals },
    { label: t('landing.stats.subscriptions'), stat: subscriptions },
    { label: t('landing.stats.paidOut'), stat: paidOut, prefix: '$' },
  ];

  return (
    <StatsBar>
      <StatsInner>
        {items.map(({ label, stat, prefix }) => (
          <StatItem key={label}>
            <StatValue>
              {prefix && <StatPrefix>{prefix}</StatPrefix>}
              <Counter to={stat.value} suffix={stat.suffix} />
            </StatValue>
            <StatLabel>{label}</StatLabel>
          </StatItem>
        ))}
      </StatsInner>
    </StatsBar>
  );
}

export default StatsSection;
